var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-footer"},[_c('p',[_vm._v("中国中医科学院中医药信息研究所 中医药大健康智能研发中心")]),_c('p',[_vm._v("地址：北京市东城区东直门内南小街16号 100700")]),_vm._t("content"),_c('p',[_vm._v("联系电话：010-64089619")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }